(function () {
  'use strict';

  var DEFAULTS = {
    apiUrl: 'https://emails.orthoticshop.com/api/signup-widget.php',
    offerText: 'Get 10% Off',
    subtitle: 'Join our email list and receive a unique 10% off coupon code.',
    showPhone: true,
    showSmsConsent: true,
    source: 'site_popup',
    delayMs: 1500,
    autoOpen: false,
    hideOnAttribution: true
  };

  var SMS_CONSENT_TEXT = 'By checking this box, you agree to receive recurring automated marketing text messages from Orthotic Shop. Consent is not a condition of purchase. Msg & data rates may apply. Reply STOP to cancel, HELP for help. Message frequency varies.';
  var HIDE_KEY = 'emailbro_signup_hidden_until';
  var SUCCESS_KEY = 'emailbro_signup_success';
  var TEST_PARAM = 'emailbro_test';

  function extend(base, override) {
    var out = {};
    var key;
    for (key in base) {
      if (Object.prototype.hasOwnProperty.call(base, key)) out[key] = base[key];
    }
    override = override || {};
    for (key in override) {
      if (Object.prototype.hasOwnProperty.call(override, key)) out[key] = override[key];
    }
    return out;
  }

  function testMode() {
    try {
      return new URLSearchParams(window.location.search).get(TEST_PARAM) === '1';
    } catch (e) {
      return window.location.search.indexOf(TEST_PARAM + '=1') !== -1;
    }
  }

  function localGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function localSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function shouldHide(isTest) {
    if (isTest) return false;
    var hiddenUntil = parseInt(localGet(HIDE_KEY) || '0', 10);
    return hiddenUntil && hiddenUntil > Date.now();
  }

  function hideForSevenDays() {
    localSet(HIDE_KEY, String(Date.now() + 7 * 24 * 60 * 60 * 1000));
  }

  function queryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]*)'));
      return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')) : '';
    }
  }

  function cookieNames() {
    try {
      return document.cookie.split(';').map(function (item) {
        return item.split('=')[0].trim();
      });
    } catch (e) {
      return [];
    }
  }

  function hasEmailBroOrSmsBroAttribution() {
    var sourceValues = [
      queryParam('eb_source'),
      queryParam('utm_source'),
      queryParam('source'),
      queryParam('sms_source'),
      queryParam('sb_source'),
      queryParam('smsbro_source')
    ].join('|').toLowerCase();

    if (sourceValues.indexOf('emailbro') !== -1 || sourceValues.indexOf('smsbro') !== -1) {
      return true;
    }

    var idParams = [
      'eb_campaign_id',
      'eb_send_id',
      'eb_automation_send_id',
      'eb_automation',
      'eb_step',
      'sms_campaign_id',
      'sms_send_id',
      'sms_automation_send_id',
      'sms_automation',
      'sms_step',
      'sb_campaign_id',
      'sb_send_id',
      'smsbro_campaign_id',
      'smsbro_send_id'
    ];
    for (var i = 0; i < idParams.length; i++) {
      if (queryParam(idParams[i])) return true;
    }

    var names = cookieNames();
    for (var j = 0; j < names.length; j++) {
      if (/^osh_eb_/.test(names[j]) || /^osh_sms_/.test(names[j]) || /^osh_smsbro_/.test(names[j]) || /^osh_sb_/.test(names[j])) {
        return true;
      }
    }

    return false;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function injectStyles() {
    if (document.getElementById('emailbro-signup-style')) return;
    var style = document.createElement('style');
    style.id = 'emailbro-signup-style';
    style.textContent =
      '#emailbro-side-tab{position:fixed!important;left:0!important;top:58%!important;transform:translate(0,-50%)!important;z-index:2147483647!important;background:#fff!important;color:#000!important;border:1px solid #000!important;border-left:0!important;padding:12px 8px!important;font:700 15px/1 Arial,sans-serif!important;writing-mode:vertical-rl!important;cursor:pointer!important;box-shadow:0 2px 8px rgba(0,0,0,.25)!important;border-radius:0!important;letter-spacing:0!important;}' +
      '#emailbro-side-tab:hover{background:#000!important;color:#fff!important;}' +
      '#emailbro-drawer{position:fixed!important;left:0!important;top:50%!important;width:390px!important;max-width:92vw!important;max-height:92vh!important;overflow:auto!important;background:#fff!important;border:1px solid #ddd!important;box-shadow:0 6px 28px rgba(0,0,0,.28)!important;padding:24px!important;box-sizing:border-box!important;z-index:2147483646!important;transform:translate(-110%,-50%)!important;transition:transform .35s ease!important;visibility:visible!important;color:#111827!important;font-family:Arial,sans-serif!important;}' +
      '#emailbro-drawer.is-open{transform:translate(0,-50%)!important;}' +
      '#emailbro-close{position:absolute!important;right:8px!important;top:4px!important;border:0!important;background:none!important;color:#000!important;font-size:30px!important;line-height:1!important;cursor:pointer!important;z-index:2!important;padding:2px 8px!important;border-radius:0!important;}' +
      '#emailbro-close:hover{opacity:.7!important;}' +
      '#emailbro-drawer *{box-sizing:border-box!important;}' +
      '#emailbro-drawer h2{margin:0 0 8px!important;text-align:center!important;font:700 30px/1.15 Arial,sans-serif!important;color:#111827!important;letter-spacing:0!important;}' +
      '#emailbro-drawer p{margin:0 0 14px!important;text-align:center!important;font:15px/1.45 Arial,sans-serif!important;color:#334155!important;letter-spacing:0!important;}' +
      '#emailbro-drawer label{display:block!important;margin:0 0 8px!important;font:13px/1.35 Arial,sans-serif!important;color:#334155!important;letter-spacing:0!important;}' +
      '#emailbro-drawer input[type="email"],#emailbro-drawer input[type="tel"]{display:block!important;width:100%!important;height:44px!important;margin:0 0 10px!important;padding:10px 12px!important;border:1px solid #cbd5e1!important;border-radius:4px!important;background:#fff!important;color:#111827!important;font:15px/1.2 Arial,sans-serif!important;box-shadow:none!important;outline:none!important;}' +
      '#emailbro-drawer input[type="email"]:focus,#emailbro-drawer input[type="tel"]:focus{border-color:#111827!important;}' +
      '#emailbro-drawer .emailbro-sms-row{display:flex!important;align-items:flex-start!important;gap:8px!important;margin:2px 0 8px!important;}' +
      '#emailbro-drawer .emailbro-sms-row input{flex:0 0 auto!important;margin:2px 0 0!important;width:16px!important;height:16px!important;}' +
      '#emailbro-drawer .emailbro-sms-row span{font:13px/1.35 Arial,sans-serif!important;color:#1f2937!important;}' +
      '#emailbro-drawer .emailbro-legal{text-align:left!important;font:11px/1.35 Arial,sans-serif!important;color:#64748b!important;margin:0 0 12px!important;}' +
      '#emailbro-drawer .emailbro-error{display:none!important;margin:0 0 10px!important;padding:9px 10px!important;background:#fff1f2!important;border:1px solid #fecdd3!important;color:#9f1239!important;text-align:left!important;font:13px/1.35 Arial,sans-serif!important;}' +
      '#emailbro-drawer .emailbro-submit{display:block!important;width:100%!important;min-height:46px!important;border:1px solid #000!important;border-radius:4px!important;background:#000!important;color:#fff!important;padding:12px 16px!important;font:700 15px/1.2 Arial,sans-serif!important;text-align:center!important;cursor:pointer!important;box-shadow:none!important;letter-spacing:0!important;}' +
      '#emailbro-drawer .emailbro-submit:disabled{opacity:.65!important;cursor:default!important;}' +
      '#emailbro-drawer .emailbro-success h3{margin:0 0 10px!important;text-align:center!important;font:700 28px/1.2 Arial,sans-serif!important;color:#111827!important;}' +
      '#emailbro-drawer .emailbro-success p{margin:0!important;text-align:center!important;font:16px/1.45 Arial,sans-serif!important;color:#334155!important;}' +
      '@media(max-width:768px){#emailbro-side-tab{font-size:14px!important;padding:10px 7px!important;}#emailbro-drawer{width:92vw!important;padding:20px!important;}}';
    document.head.appendChild(style);
  }

  function buildDrawer(config) {
    if (document.getElementById('emailbro-drawer')) return null;

    var drawer = document.createElement('div');
    drawer.id = 'emailbro-drawer';
    drawer.setAttribute('aria-hidden', 'true');
    drawer.innerHTML =
      '<button id="emailbro-close" type="button" aria-label="Close">&times;</button>' +
      '<form id="emailbro-form" novalidate>' +
      '<h2>' + escapeHtml(config.offerText) + '</h2>' +
      '<p>' + escapeHtml(config.subtitle) + '</p>' +
      '<div class="emailbro-error" role="alert"></div>' +
      '<input type="email" name="email" autocomplete="email" required placeholder="Enter your email address">' +
      (config.showPhone ? '<input type="tel" name="phone" autocomplete="tel" placeholder="Mobile number optional">' : '') +
      (config.showSmsConsent ? '<label class="emailbro-sms-row"><input type="checkbox" name="sms_consent" value="1"><span>Text me exclusive offers and updates from Orthotic Shop.</span></label><p class="emailbro-legal">' + escapeHtml(SMS_CONSENT_TEXT) + '</p>' : '') +
      '<input type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute!important;left:-10000px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important;">' +
      '<button class="emailbro-submit" type="submit">' + escapeHtml(config.offerText) + '</button>' +
      '</form>';
    document.body.appendChild(drawer);

    var tab = document.createElement('button');
    tab.id = 'emailbro-side-tab';
    tab.type = 'button';
    tab.textContent = config.offerText;
    document.body.appendChild(tab);

    return { drawer: drawer, tab: tab };
  }

  function init() {
    var isTest = testMode();
    if (!isTest && localGet(SUCCESS_KEY) === '1') return;

    var config = extend(DEFAULTS, window.emailBroWidgetConfig || {});
    if (!isTest && config.hideOnAttribution !== false && hasEmailBroOrSmsBroAttribution()) return;
    injectStyles();
    var nodes = buildDrawer(config);
    if (!nodes) return;

    var drawer = nodes.drawer;
    var tab = nodes.tab;
    var close = drawer.querySelector('#emailbro-close');
    var form = drawer.querySelector('#emailbro-form');
    var error = drawer.querySelector('.emailbro-error');
    var submit = drawer.querySelector('.emailbro-submit');

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      tab.style.display = 'none';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      hideForSevenDays();
      if (localGet(SUCCESS_KEY) !== '1') {
        tab.style.display = 'block';
      }
    }

    function showError(message) {
      error.textContent = message || 'Signup failed. Please try again.';
      error.style.display = 'block';
    }

    tab.addEventListener('click', openDrawer);
    close.addEventListener('click', closeDrawer);

    tab.style.display = 'block';
    if (config.autoOpen === true) {
      window.setTimeout(function () {
        if (!shouldHide(isTest)) openDrawer();
      }, Math.max(0, parseInt(config.delayMs, 10) || 0));
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      error.style.display = 'none';

      var email = form.elements.email ? form.elements.email.value.trim() : '';
      if (!email || email.indexOf('@') === -1) {
        showError('Please enter a valid email address.');
        return;
      }

      var payload = {
        email: email,
        phone: form.elements.phone ? form.elements.phone.value.trim() : '',
        sms_consent: form.elements.sms_consent ? form.elements.sms_consent.checked : false,
        website: form.elements.website ? form.elements.website.value.trim() : '',
        source: config.source || 'site_popup',
        source_url: window.location.href,
        referrer: document.referrer || '',
        user_agent: navigator.userAgent || ''
      };

      var originalText = submit.textContent;
      submit.disabled = true;
      submit.textContent = 'Signing up...';

      fetch(config.apiUrl, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () {
            throw new Error('Signup failed. Please try again.');
          }).then(function (data) {
            if (!response.ok || !data || data.ok === false) {
              throw new Error((data && data.message) || 'Signup failed. Please try again.');
            }
            return data;
          });
        })
        .then(function (data) {
          localSet(SUCCESS_KEY, '1');
          form.innerHTML =
            '<div class="emailbro-success">' +
            '<h3>Success!</h3>' +
            '<p>Check your email for your coupon code.</p>' +
            (data.sms_opted_in ? '<p style="margin-top:10px!important;">You&rsquo;re also signed up for text updates.</p>' : '') +
            '</div>';
        })
        .catch(function (err) {
          showError(err && err.message ? err.message : 'Signup failed. Please try again.');
          submit.disabled = false;
          submit.textContent = originalText;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
